import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-forest-950 text-center text-cream" aria-label="Oferta por tiempo limitado" data-id="element-271" data-mp="369pga49jt16e">
      <div className="furrow-bar h-2 w-full" aria-hidden="true" data-id="element-272" data-mp="31jhey9u10gu6" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-273" data-mp="31h4pzcpup67m">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-gold-300" data-id="element-274" data-mp="3g7c6vo07mh67">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-275" data-mp="3b8iujywnsw7m" /> El precio de lanzamiento termina en:
        </p>
        <Countdown light className="mt-5 scale-110" data-id="element-276" data-mp="3p80lokxfglk5" />
        <p className="mt-7 font-bold text-forest-100" data-id="element-277" data-mp="3l6yoe9n2mjkt">Después sube el precio y no vuelve a bajar.</p>

        <div className="mx-auto mt-6 max-w-xl rounded-lg border border-forest-700 bg-forest-900 p-4 text-left text-sm" data-id="element-278" data-mp="1uu0uvhby0a7p">
          <p className="flex items-center justify-between gap-3 font-bold" data-id="element-279" data-mp="1quigl4emmxdu">
            <span className="inline-flex items-center" data-id="element-280" data-mp="2sufvsdnr7os2">
              <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-red-500" aria-hidden="true" data-id="element-281" data-mp="2srto8e0v599u" />
              Cupos al precio de lanzamiento
            </span>
            <span className="text-gold-300" data-id="element-282" data-mp="32pra4uv92tza">Quedan pocos</span>
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-forest-800" data-id="element-283" data-mp="37jcb8vs5442p">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full rounded-full bg-gold-500" data-id="element-284" data-mp="3cif8hu1vp604" />
          </div>
          <p className="mt-1 text-right text-xs text-forest-100" data-id="element-285" data-mp="3qgdk4roteobx">66% de los cupos tomados</p>
        </div>
      </div>
      <div className="furrow-bar h-2 w-full" aria-hidden="true" data-id="element-286" data-mp="1r5vkac0yvshc" />
    </section>;
}